import React from 'react';
import { ConstCss } from '../../const/Const';
import { ReactComponent as OrderByIcon } from '../../svg/orderby.svg'

const IconOrder = () => {
    return (
        <div style={{ ...ConstCss.flexCenter, cursor: 'pointer' }}>
            <OrderByIcon />
        </div>
    );
}

export default IconOrder;